export const safetyKeys = {
  content: () => ['safety', 'content'] as const,
  overview: (locationId: string) => ['safety', 'overview', locationId] as const,
  staff: (locationId: string) => ['safety', 'staff', locationId] as const,
  roster: (locationId: string) => ['safety', 'roster', locationId] as const,
  course: (locationId: string, assignmentId: string) =>
    ['safety', 'course', locationId, assignmentId] as const,
  equipment: (locationId: string) => ['safety', 'equipment', locationId] as const,
  logs: (locationId: string, equipmentId?: string) =>
    ['safety', 'logs', locationId, equipmentId ?? 'all'] as const,
  records: (locationId: string) => ['safety', 'records', locationId] as const,
};
